// The dev config points the API at localhost, which on a phone means the phone
// itself. When the page was served from a LAN IP, send API calls to that same
// host instead, so one dev build works on the laptop and on a phone on the same
// WiFi with nothing to reconfigure. Production uses a relative /api and is
// resolved against the site's own origin, unchanged in effect.
const resolveApiUrl = () => {
    const configured = new URL(process.env.REACT_APP_API_URL || '/api', window.location.origin);
    const isLoopback = configured.hostname === 'localhost' || configured.hostname === '127.0.0.1';

    if (isLoopback && window.location.hostname !== configured.hostname) {
        configured.hostname = window.location.hostname;
    }

    return configured.toString().replace(/\/$/, '');
};

export const API_URL = resolveApiUrl();
